module.exports = __webpack_public_path__ + "img/工商业储能-风冷.19cfb1e3.png";